import { FloorPlan } from '../../model/floorplan.model';
import * as FloorPlanActions from '../actions/floorplan.actions';



export function floorplanReducer(state: FloorPlan = new FloorPlan(), action) {
  switch (action.type) {
    case FloorPlanActions.SET_FLOORPLAN:
        return action.payload;
    case FloorPlanActions.SEND_FLOORPLAN:
        return action.payload;
    default:
        return state;
    }
}